import React from "react";
import { Globe, BadgeCheck, Clock, Building2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { useLang } from "../i18n/LanguageContext";

const ICONS = [Globe, BadgeCheck, Clock, Building2];
const SLUGS = ["flughafentransfer", "geschaeftlich", "stundenbuchung", "stadt-zu-stadt"];

export default function CoreServices() {
  useReveal();
  const navigate = useNavigate();
  const { t, tList } = useLang();
  const services = tList("services");
  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl reveal">
          <span className="text-xs uppercase tracking-[0.2em] text-[#F5B400] font-semibold">{t("services_eyebrow")}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-black leading-tight">{t("services_title")}</h2>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[i] || Globe;
            return (
              <button key={i} onClick={() => navigate(`/service/${SLUGS[i] || "flughafentransfer"}`)} data-testid={`service-card-${i}`}
                className="reveal group text-left rounded-2xl border border-slate-100 bg-white shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 p-7" style={{ animationDelay: `${i * 0.08}s` }}>
                <div className="w-12 h-12 rounded-xl bg-[#F5B400]/10 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#F5B400]" />
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-black">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-[#F5B400] font-semibold">{t("svc_details")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
